import React, { useState } from 'react';
import './css/LayerControls.css';
import { MAP_LAYER_OPTIONS } from "../utils/tileEntityOptions";

const LayerControls = ({ layers, toggleLayer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleDropdownToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="layer-controls">
      <button className="dropdown-button" onClick={handleDropdownToggle}>
        {isOpen ? "Close Layers" : "Layer Controls"}
      </button>
      {isOpen && (
        <div className="layer-controls-menu">
          <div className="layer-group">
            <label className="layer-item">
              <input
                type="checkbox"
                checked={layers.baseGrid}
                onChange={() => toggleLayer('baseGrid')}
              />
              Base Grid
            </label>
            <label className="layer-item">
              <input
                type="checkbox"
                checked={layers.territory}
                onChange={() => toggleLayer('territory')}
              />
              Territory
            </label>
          </div>
          <div className="layer-group">
            {MAP_LAYER_OPTIONS.filter((option) => option.key !== 'baseGrid' && option.key !== 'territory').map((option) => (
              <label key={option.key} className="layer-item">
                <input
                  type="checkbox"
                  checked={layers[option.key]}
                  onChange={() => toggleLayer(option.key)}
                />
                {option.label}
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LayerControls;
